"use strict";import{TableCheckboxCell as e}from"./src/TableCheckboxCell.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-table-checkbox-cell",e);
//# sourceMappingURL=sp-table-checkbox-cell.js.map
